<template>
    <section class="hero is-medium has-custom-img">
        <div class="hero-body">
            <div class="container">
                <h1 id="title" class="title is-1">
                    Alex Stefanou's Portfolio
                </h1>
                
                <h2 class="subtitle is-2">
                    Explore a seamless web experience
                </h2>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'hero'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#title {
    margin-bottom: 5rem;
}

.title, .subtitle {
    letter-spacing: 0.4rem;
    color: white;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.5);
}

.has-custom-img {
    background: url('../../assets/home/himalayan_lake_reflection.jpg') center center;
    background-size: cover;
}
</style>
